/**
 * Linenatura — Quick view modal
 * Click en [data-quick-view] de una card → fetch /products/HANDLE.js → modal con
 * imagen, título, precio, variantes y botón "Añadir al carrito".
 */
(function () {
  'use strict';

  function lang() {
    return (document.documentElement.lang || 'es').slice(0, 2).toLowerCase();
  }
  function L(es, fr, de) {
    var l = lang();
    if (l === 'fr') return fr;
    if (l === 'de') return de;
    return es;
  }

  var modal, body, loading;

  function ensureRefs() {
    modal = modal || document.querySelector('[data-quick-view-modal]');
    body = modal ? modal.querySelector('[data-quick-view-body]') : null;
    loading = modal ? modal.querySelector('[data-quick-view-loading]') : null;
    return !!modal;
  }

  function open() {
    if (!ensureRefs()) return;
    modal.hidden = false;
    modal.setAttribute('aria-hidden', 'false');
    document.body.classList.add('ln-quickview-open');
    requestAnimationFrame(function () { modal.classList.add('ln-quickview--show'); });
  }

  function close() {
    if (!modal) return;
    modal.classList.remove('ln-quickview--show');
    modal.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('ln-quickview-open');
    setTimeout(function () { modal.hidden = true; if (body) body.innerHTML = ''; }, 200);
  }

  function fmtMoney(cents) {
    return (cents / 100).toFixed(2).replace('.', ',') + ' €';
  }

  function imageSrc(url, w) {
    if (!url) return '';
    return url.replace(/(\.(?:jpg|jpeg|png|webp|avif))(\?.*)?$/i, '_' + (w || 800) + 'x$1$2');
  }

  function renderProduct(product) {
    if (!body) return;
    var defaultVariant = product.variants[0];
    var imgs = (product.images && product.images.length) ? product.images : (product.featured_image ? [product.featured_image] : []);
    var imgUrl = imgs.length ? (typeof imgs[0] === 'string' ? imgs[0] : imgs[0].src || imgs[0]) : '';

    var optionsHtml = '';
    if (product.variants.length > 1 && product.options.length) {
      product.options.forEach(function (optName, idx) {
        var values = [];
        product.variants.forEach(function (v) {
          var val = v.options[idx];
          if (val && values.indexOf(val) === -1) values.push(val);
        });
        if (values.length <= 1) return;
        optionsHtml +=
          '<div class="ln-qv__option">' +
          '<label class="ln-qv__option-label">' + optName + '</label>' +
          '<div class="ln-qv__option-values">' +
          values.map(function (v, i) {
            var checked = (defaultVariant.options[idx] === v) ? 'checked' : '';
            var safeOpt = optName.replace(/\W/g, '');
            return '<label class="ln-qv__pill"><input type="radio" name="opt-' + safeOpt + '" value="' + v + '" data-option-index="' + idx + '" ' + checked + '><span>' + v + '</span></label>';
          }).join('') +
          '</div>' +
          '</div>';
      });
    }

    var hasCompare = defaultVariant.compare_at_price && defaultVariant.compare_at_price > defaultVariant.price;
    var priceHtml = '<span class="ln-qv__price-current">' + fmtMoney(defaultVariant.price) + '</span>' +
      (hasCompare ? '<s class="ln-qv__price-compare">' + fmtMoney(defaultVariant.compare_at_price) + '</s>' : '');

    body.innerHTML =
      '<div class="ln-qv__media">' +
        (imgUrl ? '<img src="' + imageSrc(imgUrl, 800) + '" alt="' + (product.title || '') + '" loading="lazy">' : '') +
      '</div>' +
      '<div class="ln-qv__info">' +
        '<h2 id="ln-quickview-title" class="ln-qv__title">' + product.title + '</h2>' +
        '<div class="ln-qv__price" data-qv-price>' + priceHtml + '</div>' +
        (product.description ? '<div class="ln-qv__desc">' + product.description.replace(/<[^>]+>/g, ' ').slice(0, 240) + (product.description.length > 240 ? '…' : '') + '</div>' : '') +
        '<form class="ln-qv__form" data-qv-form>' +
          '<input type="hidden" name="id" value="' + defaultVariant.id + '" data-qv-variant-id>' +
          '<input type="hidden" name="quantity" value="1">' +
          optionsHtml +
          '<button type="submit" class="ln-qv__cta button button--primary"' + (defaultVariant.available ? '' : ' disabled') + '>' +
            (defaultVariant.available
              ? L('Añadir al carrito', 'Ajouter au panier', 'In den Warenkorb')
              : L('Agotado', 'Épuisé', 'Ausverkauft')) +
          '</button>' +
        '</form>' +
        '<a href="' + product.url + '" class="ln-qv__more-link">' +
          L('Ver toda la información del producto →', 'Voir toute la fiche produit →', 'Vollständige Produktseite ansehen →') +
        '</a>' +
      '</div>';

    body.dataset.product = JSON.stringify(product);
    bindFormBehaviors(product);
  }

  function bindFormBehaviors(product) {
    var form = body.querySelector('[data-qv-form]');
    if (!form) return;

    var hiddenVariant = form.querySelector('[data-qv-variant-id]');
    var priceEl = body.querySelector('[data-qv-price]');
    var cta = form.querySelector('button[type="submit"]');

    function selectedOptions() {
      var selected = [];
      product.options.forEach(function (_, idx) {
        var radios = form.querySelectorAll('input[data-option-index="' + idx + '"]:checked');
        if (radios.length) selected[idx] = radios[0].value;
      });
      return selected;
    }

    function findVariant() {
      var chosen = selectedOptions();
      return product.variants.find(function (v) {
        return v.options.every(function (val, i) { return val === chosen[i]; });
      });
    }

    function refresh() {
      var v = findVariant();
      if (!v) return;
      hiddenVariant.value = v.id;
      var hasCompare = v.compare_at_price && v.compare_at_price > v.price;
      priceEl.innerHTML = '<span class="ln-qv__price-current">' + fmtMoney(v.price) + '</span>' +
        (hasCompare ? '<s class="ln-qv__price-compare">' + fmtMoney(v.compare_at_price) + '</s>' : '');
      cta.disabled = !v.available;
      cta.textContent = v.available
        ? L('Añadir al carrito', 'Ajouter au panier', 'In den Warenkorb')
        : L('Agotado', 'Épuisé', 'Ausverkauft');
    }

    form.addEventListener('change', refresh);

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      cta.disabled = true;
      var originalText = cta.textContent;
      cta.textContent = L('Añadiendo…', 'Ajout…', 'Wird hinzugefügt…');

      var formData = new FormData(form);
      fetch('/cart/add.js', {
        method: 'POST',
        body: formData,
        credentials: 'same-origin',
      })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (data) {
          cta.textContent = '✓ ' + L('Añadido', 'Ajouté', 'Hinzugefügt');
          // Notify cart drawer to update
          try {
            if (window.PUB_SUB_EVENTS && window.publish) {
              window.publish(window.PUB_SUB_EVENTS.cartUpdate, { source: 'ln-quick-view' });
            }
          } catch (e) {}
          // Open cart drawer if present
          setTimeout(function () {
            var drawer = document.querySelector('cart-drawer');
            if (drawer && typeof drawer.open === 'function') {
              close();
              drawer.open();
            } else {
              cta.disabled = false;
              cta.textContent = originalText;
            }
          }, 800);
        })
        .catch(function () {
          cta.textContent = L('Error, inténtalo de nuevo', 'Erreur, réessayez', 'Fehler, erneut versuchen');
          setTimeout(function () { cta.disabled = false; cta.textContent = originalText; }, 1800);
        });
    });
  }

  // Click delegation for opener buttons
  document.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest && e.target.closest('[data-quick-view]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    var handle = btn.getAttribute('data-product-handle');
    if (!handle) return;
    if (!ensureRefs()) return;

    if (loading) loading.style.display = '';
    if (body) body.innerHTML = '';
    open();

    fetch('/products/' + handle + '.js', { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (product) {
        if (loading) loading.style.display = 'none';
        if (!product) {
          body.innerHTML = '<p style="padding:2rem;text-align:center;">No se pudo cargar el producto.</p>';
          return;
        }
        renderProduct(product);
      });
  });

  // Close on overlay/close button/Escape
  document.addEventListener('click', function (e) {
    if (e.target && e.target.closest && e.target.closest('[data-quick-view-close]')) {
      close();
    }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && modal && !modal.hidden) close();
  });
})();
